import React from 'react';
import type { SvgIconProps } from '@mui/material/SvgIcon';
import SvgIcon from '@mui/material/SvgIcon';

export default function SearchIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 22C22.2929 21.7071 22.2929 21.2322 22 20.9393L16.59 15.5293C17.7825 14.0987 18.5 12.2581 18.5 10.25C18.5 5.69365 14.8063 2 10.25 2C5.69365 2 2 5.69365 2 10.25C2 14.8063 5.69365 18.5 10.25 18.5C12.2581 18.5 14.0987 17.7825 15.5293 16.59L20.9393 22C21.2322 22.2929 21.7071 22.2929 22 22ZM10.25 3.5C6.52208 3.5 3.5 6.52208 3.5 10.25C3.5 13.9779 6.52208 17 10.25 17C13.9779 17 17 13.9779 17 10.25C17 6.52208 13.9779 3.5 10.25 3.5Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 22C22.2929 21.7071 22.2929 21.2322 22 20.9393L16.59 15.5293C17.7825 14.0987 18.5 12.2581 18.5 10.25C18.5 5.69365 14.8063 2 10.25 2C5.69365 2 2 5.69365 2 10.25C2 14.8063 5.69365 18.5 10.25 18.5C12.2581 18.5 14.0987 17.7825 15.5293 16.59L20.9393 22C21.2322 22.2929 21.7071 22.2929 22 22ZM10.25 3.5C6.52208 3.5 3.5 6.52208 3.5 10.25C3.5 13.9779 6.52208 17 10.25 17C13.9779 17 17 13.9779 17 10.25C17 6.52208 13.9779 3.5 10.25 3.5Z"
      />
    </SvgIcon>
  );
}
